<header class="sf-header">
  <h1>{{ 'public-profile.title' | transloco }}</h1>

  @if (user) {
    <a class="button" [routerLink]="['/photographer', user.slug]" target="_blank">
      {{ 'public-profile.preview' | transloco }}
      <i class="fa-solid fa-arrow-up-right-from-square"></i>
    </a>
  }
</header>

<div class="public-profile">
  <!-- Online Section -->
  <section id="online" class="sf-section public-profile__section public-profile__section--online">
    <div class="left">
      <h2 class="public-profile__section-title">{{'public-profile.online.title' | transloco}}</h2>
      <p>{{'public-profile.online.content' | transloco}}</p>
    </div>
    <div class="right">
      <app-toggle
        [toggled]="profileForm.value.online"
        (onChange)="changeOnlineStatus($event)"
      ></app-toggle>
    </div>
  </section>

  <!-- Identity Section -->
  <section id="identity" class="sf-section public-profile__section">
    <h2 class="public-profile__section-title">{{'public-profile.identity.title' | transloco}}</h2>

    <div class="public-profile__section-info">
      <div class="public-profile__section-info__icon">
        <i class="fa-solid fa-circle-info"></i>
      </div>
      <div class="public-profile__section-info__content">
        <p>{{'public-profile.identity.info' | transloco}}</p>
      </div>
    </div>

    <form [formGroup]="profileForm" class="public-profile__section-form">
      <!-- Name Input -->
      <div class="input-group--side-by-side">
        <div class="input-group">
          <label>{{'public-profile.identity.firstname.label' | transloco}}</label>
          <input type="text"
            formControlName="firstname"
            placeholder="{{'public-profile.identity.firstname.placeholder' | transloco}}"
            autocomplete="given-name" />
        </div>
        <div class="input-group">
          <label>{{'public-profile.identity.lastname.label' | transloco}}</label>
          <input type="text"
            formControlName="lastname"
            placeholder="{{'public-profile.identity.lastname.placeholder' | transloco}}"
            autocomplete="family-name" />
        </div>
      </div>

      <!-- City Input -->
      <app-city-selector
        formControlName="city"
      ></app-city-selector>

      <hr/>

      <!-- User Image -->
      <h3>{{'public-profile.identity.image.label' | transloco}}</h3>
      <div class="public-profile__section-image">
        <app-user-image
          class="public-profile__section-image__left"
          [user]="user"
          [size]="152"
        ></app-user-image>
        <div class="public-profile__section-image__right">
          <!-- File Input & Button -->
          <label class="upload-button">
            <input type="file" hidden (change)="onImageSelected($event)" accept="image/*" />
            <div class="button button--small">
              <i class="fa-solid fa-upload"></i>
              {{ 'public-profile.identity.image.upload-button' | transloco }}
            </div>
          </label>

          <!-- Optional: Show selected file name or preview -->
          @if (selectedFileName) {
            <p class="selected-file">{{ selectedFileName }}</p>
          }

          <!-- Additional Info for User Image -->
          <div class="public-profile__section-info">
            <div class="public-profile__section-info__icon">
              <i class="fa-solid fa-circle-info"></i>
            </div>
            <div class="public-profile__section-info__content">
              <p [innerHTML]="'public-profile.identity.image.info' | transloco"></p>
            </div>
          </div>
        </div>
      </div>

      <hr/>

      <!-- Tags Input -->
      <app-tags-selector
        formControlName="tags"
        [max]="5"
        (maxReached)="showErrorToast('public-profile.identity.tags.error.max-5')"
      ></app-tags-selector>

      <!-- Additional Info for Tags -->
      <div class="public-profile__section-info">
        <div class="public-profile__section-info__icon">
          <i class="fa-solid fa-circle-info"></i>
        </div>
        <div class="public-profile__section-info__content">
          <p [innerHTML]="'public-profile.identity.tags.info' | transloco"></p>
        </div>
      </div>

      <hr/>

      <!-- Biography -->
      <div class="input-group">
        <label>{{'public-profile.identity.biography.label' | transloco}}</label>
        <textarea formControlName="biography">{{'public-profile.identity.biography.placeholder' | transloco}}</textarea>
      </div>

      <!-- Additional Info for Biography -->
      <div class="public-profile__section-info">
        <div class="public-profile__section-info__icon">
          <i class="fa-solid fa-circle-info"></i>
        </div>
        <div class="public-profile__section-info__content">
          <p [innerHTML]="'public-profile.identity.biography.info' | transloco"></p>
        </div>
      </div>
    </form>
  </section>

  <app-public-profile-portfolio></app-public-profile-portfolio>
</div>


<footer class="public-profile__footer">
  <button class="button"
          [disabled]="profileForm.invalid || formSubmitted"
          [class.button--loading]="formSubmitted"
          (click)="submitForm()"
  >
    <i class="fa-solid fa-floppy-disk"></i>
    {{'public-profile.identity.save' | transloco}}
  </button>
</footer>
